const isValidTriggerFilterForm = (values) => {
  var _a, _b;
  let errors = {};
  if (!values.isJobProfileSideStreamEnabled && values.isEnabledTriggerFilter) {
    if (!((_a = values.triggerFilterConditionName) == null ? void 0 : _a.trim())) {
      errors.triggerFilterConditionName = "Required";
    }
    if (!((_b = values.triggerFilterExpression) == null ? void 0 : _b.trim())) {
      errors.triggerFilterExpression = "Required";
    }
  }
  return errors;
};
export {
  isValidTriggerFilterForm
};
//# sourceMappingURL=TriggerFilterForm.validation.js.map
